"use client";
import { useSearchParams } from "next/navigation";
import { Box } from "@mui/material";

import FourUp from "./FourUp";
import Top100 from "./Top100";

export default function Results() {
  const searchParams = Object.fromEntries(useSearchParams().entries());
  const type = {
    models: "models",
    papers: "papers",
    videos: "videos",
    tasks: "tasks"
  }[searchParams.type?.toLowerCase?.()];
  const Results = type ? Top100 : FourUp;

  return (
    <Box pl={1}>
      <Results searchParams={searchParams} />
    </Box>
  );
}
